.inputContainer {
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1;
  padding: 5px 10px;
}

.inputContainerV2 {
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1;
  max-height: 300px;
  /* overflow-y: auto; */
  padding: 5px 0px;
}
